export default __webpack_public_path__ + "static/ge-7b66cc7b1fa080603c8da409b00ce9bb.png";